import { GetterTree } from 'vuex'
import * as types from './types'

export default <GetterTree<workflow.state.WorkflowState, RootState>>{
    [types.WORKFLOW_CURRENT](state) {
        return state.workflows.current;
    },

    [types.GET_WORKFLOW_OPTIONS](state){
        return state.options;
    },
}
